var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-width":"1024px"}},[_c('Navigation'),_c('Content'),_c('div',{staticClass:"new-games-bottom"},[_c('Bottom')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }